import { contestDeviceSizes, deviceSizes } from '../tokens/size';

export const device = {
  xsmall: `screen and (max-width: ${deviceSizes.xsmall}px)`,
  small: `screen and (max-width: ${deviceSizes.small}px)`,
  medium: `screen and (max-width: ${deviceSizes.medium}px)`,
  large: `screen and (max-width: ${deviceSizes.large}px)`,
  xLarge: `screen and (max-width: ${deviceSizes.xLarge}px)`,
};

export const contestDevice = {
  xsmall: `screen and (max-width: ${contestDeviceSizes.xsmall}px)`,
  small: `screen and (max-width: ${contestDeviceSizes.small}px)`,
  medium: `screen and (max-width: ${contestDeviceSizes.medium}px)`,
  large: `screen and (max-width: ${contestDeviceSizes.large}px)`,
};
